var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab8"
  }, [_c('Card', {
    staticClass: "adt_card"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v($t("i5rvf04", "账号相关"))]), _c('div', {
    staticClass: "adt_account"
  }, [_c('div', {
    staticClass: "adt_account_title"
  }, [_vm._v($t("q5wk3q5", "用户账号："))]), _c('Input', {
    staticClass: "adt_account_input",
    attrs: {
      "placeholder": $t("2j1oau5", "请输入账号")
    },
    model: {
      value: _vm.mobile,
      callback: function ($$v) {
        _vm.mobile = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "mobile"
    }
  })], 1), _c('div', {
    staticClass: "adt_account_input_pop"
  }, [_vm._v(` ${$t("e935swk", "手动输入账号，直接将具体账号同步至子应用")} `)]), _c('div', {
    staticClass: "adt_action"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.accountLoading
    },
    on: {
      "click": _vm.onChangeAccount
    }
  }, [_vm._v($t("9d3ggqa", "账号同步全部字段数据"))])], 1)]), _c('Card', {
    staticClass: "adt_card"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v($t("4vvtdt6", "基础数据相关"))]), _c('div', {
    staticClass: "adt_account_role_pop"
  }, [_vm._v($t("16oiyyb", "手工动触发数据同步任务"))]), _c('div', {
    staticClass: "adt_action_role"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.roleLoading
    },
    on: {
      "click": function ($event) {
        return _vm.onChangeRole('T');
      }
    }
  }, [_vm._v($t("5eg7888", "角色数据增量同步"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.roleLoading
    },
    on: {
      "click": function ($event) {
        return _vm.onChangeRole('F');
      }
    }
  }, [_vm._v($t("6b6x0i8", "角色数据全量同步"))])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };